import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Home from "@/pages/Home";
import Match from "@/pages/Match";
import Bracket from "@/pages/Bracket";
import History from "@/pages/History";
import Tournament from "@/pages/Tournament";
import Compare from "@/pages/Compare";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/match" element={<Match />} />
          <Route path="/match/:id" element={<Match />} />
          <Route path="/bracket" element={<Bracket />} />
          <Route path="/tournament" element={<Tournament />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/history" element={<History />} />
        </Routes>
        <Toaster theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
